import { Heading, Text } from "@sentricmusic/ui";
import { useTranslation } from "react-i18next";

import Spacer from "@/components/Spacer";

function SignUpMessage() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-center p-4 text-center min-h-screen-minus-footer">
          <Heading as="h1" className="text-white">
            {t("auth:verify-email-header")}
          </Heading>
          <div className="w-full text-white lg:w-2/3">
            <Spacer />
            <Text as="bodyLg" className="text-white">{t("auth:verify-email-text")}</Text>
          </div>

        </div>
      </div>
    </div>
  );
}

export default SignUpMessage;
